import { AccessorFnColumnDef } from "@tanstack/react-table";
import { FormSchemaField } from "PFApp/types/activity_form/activity_form_schema";
import { Id } from "PFCore/types";
import { ReactNode } from "react";

import { ManageRolesFieldCell } from "./parts/manage_roles_field_cell";

export function wrapColumnsWithHighlight<T>(
  columns: AccessorFnColumnDef<T, any>[],
  getRoleId: (rowIndex: number, row: T) => Id | undefined,
  getField: (column: AccessorFnColumnDef<T, any>) => FormSchemaField,
  getIsReadonlyColumn?: (column: AccessorFnColumnDef<T, any>) => boolean
): AccessorFnColumnDef<T, any>[] {
  return columns.map((col) => {
    const originalCell = col.cell as ((info: any) => ReactNode) | undefined;
    if (!originalCell) {
      return col;
    }

    const field = getField(col);
    return {
      ...col,
      cell: (info: any) => (
        <ManageRolesFieldCell
          roleId={getRoleId(info.row.index, info.row.original)}
          field={field}
          additionalCellData={info.additionalCellData}
          isReadonlyColumn={getIsReadonlyColumn?.(col)}
        >
          {originalCell(info)}
        </ManageRolesFieldCell>
      )
    };
  });
}
